import { instance } from '@/api/index';

function getCountryCodes() {
    return instance.get("/commons/country-codes");
}

export { getCountryCodes};
